import React from "react";
import { useTranslation } from "react-i18next";
import ExpandableTable from "../Fundamentals/Tables/ExpandedableTable";
import helpers from "../../Utils";
import useSortingAndFiltering from "../../Hooks/useSortingAndFiltering";
import jsonUtils from "../../Utils/jsonUtils";

const COLUMN_KEYS = {
    TYPE: "type",
    CLIENT_ID: "clientId",
    SOURCE: "source",
    CREATED: "created",
    INFO: "info",
    PERFORMER_EMAIL: "performerEmail"
};

export const EventLogResults = ({ logs }) => {
    const { t } = useTranslation();
    
    const defaultComparer = (a, b) => {
        // Default sort by created date descending
        const aDate = new Date(a[COLUMN_KEYS.CREATED]).getTime();
        const bDate = new Date(b[COLUMN_KEYS.CREATED]).getTime();
        return bDate - aDate;
    };
    
    const { filteredAndSortedList, handleSortChange, getSortIcon } = useSortingAndFiltering({
        list: logs,
        searchText: "",
        searchableKeys: [COLUMN_KEYS.TYPE, COLUMN_KEYS.CLIENT_ID, COLUMN_KEYS.SOURCE],
        defaultComparer
    });


    return <ExpandableTable>
        <thead>
            <tr className="cursorpointer">
                <th onClick={() => handleSortChange(COLUMN_KEYS.PERFORMER_EMAIL)}>
                    {t("loggingContainer.performedBy")}{getSortIcon(COLUMN_KEYS.PERFORMER_EMAIL)}
                </th>
                <th onClick={() => handleSortChange(COLUMN_KEYS.CLIENT_ID)}>
                    {t("loggingContainer.performedFrom")}{getSortIcon(COLUMN_KEYS.CLIENT_ID)}
                </th>
                <th onClick={() => handleSortChange(COLUMN_KEYS.SOURCE)}>
                    {t("loggingContainer.source")}{getSortIcon(COLUMN_KEYS.SOURCE)}
                </th>
                <th onClick={() => handleSortChange(COLUMN_KEYS.INFO)}>
                    {t('activitylogtable.info')}{getSortIcon(COLUMN_KEYS.INFO)}
                </th>
                <th onClick={() => handleSortChange(COLUMN_KEYS.TYPE)}>
                    {t('activitylogtable.event')}{getSortIcon(COLUMN_KEYS.TYPE)}
                </th>
                <th onClick={() => handleSortChange(COLUMN_KEYS.CREATED)}>
                    {t('actionlogcontainer.time')}{getSortIcon(COLUMN_KEYS.CREATED)}
                </th>
            </tr>
        </thead>
        <ExpandableTable.Body>
            {filteredAndSortedList?.length > 0 ? (
                filteredAndSortedList.map((log) => (
                <ExpandableTable.Row key={log.rowKey}>
                    <ExpandableTable.Row.Expandable>
                        <td>{log.performerEmail}</td>
                        <td>{log.clientId === "businessautomationv2client" || log.clientId === "businessautomationclient" ? "Skynet" : log.clientId}</td>
                        <td>{log.source}</td>
                        <td>{log.info}</td>
                        <td>{log.type}</td>
                        <td>{helpers.formatDateAndTime(log.created)}</td>
                    </ExpandableTable.Row.Expandable>
                    <ExpandableTable.Row.Expanded>
                        <tr>
                            <td colSpan={100}>
                                <div>
                                    {jsonUtils.formatJsonObject(log.content)}
                                </div>
                            </td>
                        </tr>

                    </ExpandableTable.Row.Expanded>
                </ExpandableTable.Row>
                ))
            ) : (
                <tr>
                    <td colSpan={6}>
                        {t('actionlogcontainer.noentriesfound')}
                    </td>
                </tr>
            )}
        </ExpandableTable.Body>
    </ExpandableTable>

}